import { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import Routers from "./Routers/Routers";

const App = () => {
  return (
    <Fragment>
      <Routers />
      <ToastContainer />
    </Fragment>
  );
};

export default App;
